import ApplicationAdapter from './application';

export default class Timeframe extends ApplicationAdapter {
  namespace = 'dates/v4';
  modelNamePlural = 'timeframes';
}
